import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import Header from './Header';
import Details from './Details';
import Note from './Note';
import triggerChangePaymentDueDateAnalytics from '../../helpers/trigger-change-payment-due-date-analytics';
import { PAGE_NAME } from '../../const/analytics';
import { ConfigContext } from '../../context';
import { changePaymentDueDateGetCacheKey } from '../../../../services/change-payment-due-date/get/change-payment-due-get-cache-key';
const Successful = ({ currentDueDay, selectedDay, isPromoExtended = false }) => {
    const { selectedAccountId } = useContext(ConfigContext);
    const queryClient = useQueryClient();
    useEffect(() => {
        triggerChangePaymentDueDateAnalytics({
            pageName: PAGE_NAME.COMPLETE,
            ...(isPromoExtended && {
                message: 'the expiration date of your existing promotion has changed'
            })
        });
    }, [isPromoExtended]);
    useEffect(() => {
        return () => {
            queryClient.invalidateQueries(changePaymentDueDateGetCacheKey({
                accountId: selectedAccountId,
                accountIdType: 'guid'
            }));
        };
    }, [queryClient, selectedAccountId]);
    return (_jsxs("div", { "data-testid": "successful-screen", children: [_jsx(Header, { isPromoExtended: isPromoExtended }), _jsx(Details, { currentDueDay: currentDueDay, selectedDay: selectedDay }), _jsx(Note, {})] }));
};
export default Successful;
